// @ts-nocheck — TODO: tipizzare progressivamente (modulo grande, 698 righe)
// ====== Clienti ======
const _referenti = [];
const _documenti = [];
const _scadenze = [];
let _clientSnapshot = null; // snapshot per dirty-check del modal cliente
let _suppressDirtyCheck = false; // bypassa il check (es. dopo salvataggio riuscito)

// Il percorso guidato "nuovo cliente" (setupClientWizard/wizardGo/isWizardMidStep)
// è in js/ui/clienti-wizard.js ed è disponibile come funzione globale.

function snapshotClientForm() {
  const f = $('#formCliente');
  if (!f) return null;
  return JSON.stringify({
    nome: f.nome?.value || '',
    cpl: f.cpl?.value || '',
    pm1: f.pm1?.value || '',
    pm2: f.pm2?.value || '',
    serviceLineRef: f.serviceLineRef?.value || '',
    tenantId: f.tenantId?.value || '',
    ruolo: f.ruolo?.value || '',
    assegnazionePerenne: f.assegnazionePerenne?.value || '',
    directory: f.directory?.value || '',
    pim: f.pim?.value || '',
    note: f.note?.value || '',
    perimetri: $$('#perimetriGrid input[name="perimetro"]:checked')
      .map((i) => i.value)
      .sort(),
    tecnici: $$('#tecniciGrid input[name="tecnico"]:checked')
      .map((i) => i.value)
      .sort(),
    accessi: $$('#resourceGrid select').reduce((acc, s) => {
      if (s.value) acc[s.dataset.resource] = s.value;
      return acc;
    }, {}),
    contratto: {
      numero: f.contrattoNumero?.value || '',
      tipo: f.contrattoTipo?.value || '',
      inizio: f.contrattoInizio?.value || '',
      fine: f.contrattoFine?.value || '',
      ore: f.contrattoOre?.value || '',
      importo: f.contrattoImporto?.value || '',
      note: f.contrattoNote?.value || ''
    },
    referenti: _referenti.map((r) => ({ ...r, id: undefined })),
    documenti: _documenti.map((d) => ({ ...d, id: undefined })),
    scadenze: _scadenze.map((s) => ({ ...s, id: undefined }))
  });
}

function isClientFormDirty() {
  if (_suppressDirtyCheck) return false;
  if (!_clientSnapshot) return false;
  return snapshotClientForm() !== _clientSnapshot;
}

async function tryCloseClientModal() {
  if (!isClientFormDirty()) {
    closeModals();
    _clientSnapshot = null;
    return;
  }
  const ok = await confirmAction({
    level: 'warning',
    title: 'Modifiche non salvate',
    message: 'Hai modifiche non salvate sulla scheda di questo cliente.',
    details: [
      'Chiudendo la finestra ora perderai tutto',
      'Per salvarle clicca "Salva" prima di chiudere'
    ],
    confirmText: 'Chiudi senza salvare',
    cancelText: 'Continua a modificare'
  });
  if (ok) {
    closeModals();
    _clientSnapshot = null;
  }
}

// S4: getFilteredClienti / maybeFuzzyServerSearch / populateFilters sono ora in
// js/ui/clienti-filters.js (estratte per ridurre la dimensione di questo modulo).
// Restano usate qui come funzioni globali (esposte su globalThis da quel file).

function renderClienti() {
  if (!$('#tbodyClienti')) return; // vista "clienti" lazy non ancora montata
  wireClientiView();
  populateFilters();
  bulkUpdateToolbar?.();
  const list = getFilteredClienti();
  const tbody = $('#tbodyClienti');
  const showBulk = isAdmin();
  // Query attiva: per evidenziare i match in nome/CPL/PM/perimetri
  const q = ($('#clientiSearch')?.value || '').trim();
  const hm = (text) =>
    typeof highlightMatch === 'function' ? highlightMatch(text, q) : escapeHtml(text);
  tbody.innerHTML =
    list
      .map((c) => {
        const accessSummary = state.resources
          .map((r) => {
            const v = c.accessi?.[r] || '';
            if (!v) return '';
            const meta = c.accessiMeta?.[r];
            const tipParts = [escapeHtml(r) + ': ' + escapeHtml(v)];
            if (meta?.modifiedAt) tipParts.push('Mod: ' + fmtDateTime(meta.modifiedAt));
            if (meta?.modifiedByName) tipParts.push('Da: ' + escapeHtml(meta.modifiedByName));
            const tip = tipParts.join(' · ');
            return `<span class="access-pill ${statusClass(v)}" title="${tip}"><span class="ap-sym" aria-hidden="true">${statusSymbol(v)}</span>${initials(r)}<span class="access-tip">${tip.replace(/ · /g, '<br>')}</span></span>`;
          })
          .join('');
        const perimetriHtml =
          (c.perimetri || [])
            .map((p) => `<span class="perimeter-pill ${perimetroClass(p)}">${hm(p)}</span>`)
            .join('') || '<span class="muted">—</span>';
        const checked = _bulkSelected?.has(c.nome) ? 'checked' : '';
        const checkCell = showBulk
          ? `<td class="tcell-min"><input type="checkbox" class="row-check" data-bulk-name="${escapeHtml(c.nome)}" ${checked}></td>`
          : '';
        return `
      <tr data-name="${escapeHtml(c.nome)}">
        ${checkCell}
        <td data-label="Cliente"><strong>${hm(c.nome)}</strong></td>
        <td data-label="CPL">${hm(c.cpl || '—')}</td>
        <td data-label="PM1">${hm(c.pm1 || '—')}</td>
        <td data-label="PM2">${hm(c.pm2 || '—')}</td>
        <td data-label="Perimetri"><div class="perimeter-cells">${perimetriHtml}</div></td>
        <td data-label="Accessi"><div class="access-cells">${accessSummary || '<span class="muted">—</span>'}</div></td>
        <td class="tcell-min">
          <button class="btn btn-icon btn-export-pdf" title="Esporta PDF" aria-label="Esporta cliente in PDF" data-pdf="${escapeHtml(c.nome)}"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="15" y2="17"/></svg></button>
          <button class="btn btn-icon" title="Apri" aria-label="Apri scheda cliente"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg></button>
        </td>
      </tr>`;
      })
      .join('') ||
    (() => {
      // Empty state stylato: distinguiamo "nessun dato" da "nessun match filtri"
      const hasFilters =
        ($('#clientiSearch')?.value || '').trim() ||
        $('#filterPM')?.value ||
        $('#filterAmbiente')?.value ||
        $('#filterRisorsa')?.value ||
        $('#filterStato')?.value;
      const cols = showBulk ? 8 : 7;
      const empty = document.createElement('tbody');
      if (typeof emptyState === 'function') {
        emptyState(empty, cols, {
          title: hasFilters ? 'Nessun cliente per i filtri attuali' : 'Nessun cliente in archivio',
          message: hasFilters
            ? 'Prova a rimuovere qualche filtro o cambia la ricerca.'
            : 'Crea il primo cliente per iniziare a usare il portale.',
          ctaLabel: hasFilters ? 'Reset filtri' : isAdmin() ? '+ Nuovo cliente' : null,
          onCta: hasFilters
            ? () => document.getElementById('btnClearFilters')?.click()
            : isAdmin()
              ? () => document.getElementById('btnAddClient')?.click()
              : null
        });
        return empty.innerHTML;
      }
      return `<tr><td colspan="${cols}" style="text-align:center;padding:30px;color:var(--text-muted)">Nessun cliente trovato.</td></tr>`;
    })();
  tbody.querySelectorAll('tr[data-name]').forEach((tr) => {
    tr.addEventListener('click', (e) => {
      // Ignora click su checkbox e bottone PDF
      if (e.target.closest('.row-check') || e.target.closest('[data-pdf]')) return;
      openModal(tr.dataset.name);
    });
  });
  tbody.querySelectorAll('[data-pdf]').forEach((b) =>
    b.addEventListener('click', (e) => {
      e.stopPropagation();
      exportClientePDF(b.dataset.pdf);
    })
  );
  tbody.querySelectorAll('.row-check').forEach((cb) =>
    cb.addEventListener('change', () => {
      bulkToggle(cb.dataset.bulkName, cb.checked);
    })
  );
}

function openModal(name = null, tab = 'anagrafica') {
  globalThis.editingClientName = name;
  const cli = name ? state.clients.find((c) => c.nome === name) : null;
  if (!cli && !isAdmin()) {
    toast('Solo gli amministratori possono creare nuovi clienti');
    return;
  }
  if (!isAdmin()) tab = 'accessi';

  // Skeleton flash mentre il modal popola i campi (riduce lo sfarfallio)
  const modal = $('#modalCliente');
  modal.classList.remove('hidden');
  const body = modal.querySelector('.modal-body');
  if (body && cli) {
    // Mostra skeleton solo se carichiamo un cliente esistente con molti dati
    body.classList.add('modal-loading');
    setTimeout(() => body.classList.remove('modal-loading'), 80);
  }

  $('#modalTitle').textContent = cli ? 'Cliente: ' + cli.nome : 'Nuovo Cliente';
  // Suggerimento "compila l'essenziale" solo quando si crea un cliente nuovo
  $('#newClientHint')?.classList.toggle('hidden', !!cli);
  $('#btnDeleteCliente').classList.toggle('hidden', !cli || !isAdmin());

  // Blocco "Duplica da": visibile solo per nuovi clienti
  const dupBlock = $('#duplicateFromBlock');
  const dupSelect = $('#duplicateFromSelect');
  if (dupBlock && dupSelect) {
    const showDup = !cli && isAdmin() && state.clients.length > 0;
    dupBlock.style.display = showDup ? '' : 'none';
    if (showDup) {
      const sorted = [...state.clients].sort((a, b) => a.nome.localeCompare(b.nome));
      dupSelect.innerHTML =
        '<option value="">— Nessuna duplicazione —</option>' +
        sorted
          .map((c) => `<option value="${escapeHtml(c.nome)}">${escapeHtml(c.nome)}</option>`)
          .join('');
      dupSelect.value = '';
    }
  }

  const f = $('#formCliente');
  f.reset();
  const data = cli ? cli : defaultClient();
  f.nome.value = data.nome;
  if (f.cpl) f.cpl.value = data.cpl || '';
  if (f.pm1) f.pm1.value = data.pm1 || '';
  if (f.pm2) f.pm2.value = data.pm2 || '';
  if (f.serviceLineRef) f.serviceLineRef.value = data.serviceLineRef || '';
  f.tenantId.value = data.tenantId || '';
  f.ruolo.value = data.ruolo || '';
  f.assegnazionePerenne.value = data.assegnazionePerenne || '';
  f.directory.value = data.directory || '';
  f.pim.value = data.pim || '';
  f.note.value = data.note || '';

  const perRoot = $('#perimetriGrid');
  if (perRoot) {
    const selected = new Set(data.perimetri || []);
    perRoot.innerHTML = PERIMETRI.map(
      (p) => `
      <label class="perimeter-check">
        <input type="checkbox" name="perimetro" value="${escapeHtml(p)}" ${selected.has(p) ? 'checked' : ''}>
        <span class="perimeter-pill ${perimetroClass(p)}">${escapeHtml(p)}</span>
      </label>`
    ).join('');
  }

  const tecRoot = $('#tecniciGrid');
  if (tecRoot) {
    const selectedTec = new Set(data.tecnici || []);
    tecRoot.innerHTML = state.resources
      .map(
        (r) => `
      <label class="tecnico-check">
        <input type="checkbox" name="tecnico" value="${escapeHtml(r)}" ${selectedTec.has(r) ? 'checked' : ''}>
        <span>${escapeHtml(r)}</span>
      </label>`
      )
      .join('');
  }

  const ct = data.contratto || {};
  f.contrattoNumero.value = ct.numero || '';
  f.contrattoTipo.value = ct.tipo || '';
  f.contrattoInizio.value = ct.inizio || '';
  f.contrattoFine.value = ct.fine || '';
  f.contrattoOre.value = ct.ore || '';
  f.contrattoImporto.value = ct.importo || '';
  f.contrattoNote.value = ct.note || '';

  const grid = $('#resourceGrid');
  const myResource = getCurrentUser()?.resourceName || '';
  const utenteMode = isUtente() && myResource;

  // Per gli utenti: la propria risorsa va in cima alla lista
  const sortedResources = utenteMode
    ? [myResource, ...state.resources.filter((r) => r !== myResource)]
    : state.resources;

  const banner = utenteMode
    ? `<div class="my-access-banner">Puoi modificare solo lo stato del <strong>tuo</strong> accesso a questo cliente. Le altre risorse sono in sola lettura.</div>`
    : '';

  grid.innerHTML =
    banner +
    sortedResources
      .map((r) => {
        const current = data.accessi?.[r] || '';
        const isMine = utenteMode && r === myResource;
        const disabled = utenteMode && !isMine ? 'disabled' : '';
        const rowCls = isMine ? 'resource-row resource-row-mine' : 'resource-row';
        return `
      <div class="${rowCls}">
        <label>${escapeHtml(r)}${isMine ? ' <span class="mine-tag">(tu)</span>' : ''}</label>
        <select data-resource="${escapeHtml(r)}" ${disabled}>
          ${STATUS_OPTIONS.map((s) => `<option value="${s}" ${s === current ? 'selected' : ''}>${s || '—'}</option>`).join('')}
        </select>
      </div>`;
      })
      .join('');

  renderReferentiList(data.referenti);
  renderDocumentiList(data.documenti);
  renderScadenzeListModal(data.scadenze);
  renderStoricoCliente(data.nome);

  const peopleSet = new Set();
  state.clients.forEach((c) => {
    if (c.cpl) peopleSet.add(c.cpl);
    if (c.pm1) peopleSet.add(c.pm1);
    if (c.pm2) peopleSet.add(c.pm2);
  });
  // Includi anche i nomi della rubrica persone interne (se popolata)
  (state.persone || []).forEach((p) => {
    if (p?.nome) peopleSet.add(p.nome);
  });
  $('#pmList').innerHTML = [...peopleSet]
    .sort()
    .map((p) => `<option value="${escapeHtml(p)}">`)
    .join('');

  // Aggiorna i badge di conteggio sui tab
  const counts = {
    accessi: Object.values(data.accessi || {}).filter((v) => v && v !== 'No' && v !== 'N/A').length,
    contratto:
      data.contratto && Object.values(data.contratto).some((v) => v && String(v).trim()) ? 1 : 0,
    referenti: (data.referenti || []).length,
    documenti: (data.documenti || []).length,
    scadenze: (data.scadenze || []).length,
    storico: data.nome ? state.auditLog.filter((a) => a.target === data.nome).length : 0
  };
  Object.entries(counts).forEach(([k, n]) => {
    const span = document.querySelector(`#modalCliente .tab-count[data-tab-count="${k}"]`);
    if (span) {
      span.textContent = n;
      span.classList.toggle('zero', n === 0);
    }
  });

  switchTab(tab);
  // Nuovo cliente (admin): attiva il percorso guidato a passi.
  setupClientWizard(!cli && isAdmin());
  $('#modalCliente').classList.remove('hidden');

  // Snapshot per dirty-check (rilevamento modifiche non salvate)
  _suppressDirtyCheck = false;
  _clientSnapshot = snapshotClientForm();

  // Registra il guard globale
  if (typeof registerDirtyGuard === 'function') {
    registerDirtyGuard(
      'modal-cliente',
      () => isClientFormDirty(),
      `Scheda cliente${name ? ' "' + name + '"' : ''}`
    );
  }
  // Cliente nuovo: porta subito il cursore sul nome per iniziare a digitare.
  if (!cli) setTimeout(() => $('#formCliente')?.nome?.focus(), 60);
}

function switchTab(tab) {
  if (!isAdmin()) tab = 'accessi';
  globalThis.currentTab = tab;
  $$('#modalCliente .tab').forEach((t) => t.classList.toggle('active', t.dataset.tab === tab));
  $$('#modalCliente .tab-pane').forEach((p) =>
    p.classList.toggle('active', p.dataset.pane === tab)
  );
}

function closeModals() {
  $('#modalCliente').classList.add('hidden');
  $('#modalRisorsa').classList.add('hidden');
  $('#modalUser').classList.add('hidden');
  // I modal sono chiusi: rimuovo i guard
  if (typeof unregisterDirtyGuard === 'function') {
    unregisterDirtyGuard('modal-cliente');
    unregisterDirtyGuard('modal-utente');
    unregisterDirtyGuard('modal-risorsa');
  }
}

// NB: renderReferentiList, renderDocumentiList, renderScadenzeListModal, bindItemList
// sono ora in clienti-sublists.js (estratte per ridurre la dimensione di questo modulo).

// Event listeners aggiungi items
document.getElementById('btnAddReferente').addEventListener('click', () => {
  _referenti.push({ id: uid(), nome: '', ruolo: '', email: '', telefono: '', note: '' });
  renderReferentiList(_referenti);
});
document.getElementById('btnAddDocumento').addEventListener('click', () => {
  _documenti.push({ id: uid(), titolo: '', tipo: '', url: '', note: '' });
  renderDocumentiList(_documenti);
});
document.getElementById('btnAddScadenza').addEventListener('click', () => {
  _scadenze.push({ id: uid(), titolo: '', tipo: '', data: '', note: '', completata: false });
  renderScadenzeListModal(_scadenze);
});

// "Duplica da cliente esistente": pre-compila i campi del form
document.getElementById('duplicateFromSelect').addEventListener('change', (e) => {
  const src = state.clients.find((c) => c.nome === e.target.value);
  if (!src) return;
  const f = $('#formCliente');
  // Campi copiati: tutto tranne nome, tenantId, note, contratto, referenti/documenti/scadenze
  if (f.cpl) f.cpl.value = src.cpl || '';
  if (f.pm1) f.pm1.value = src.pm1 || '';
  if (f.pm2) f.pm2.value = src.pm2 || '';
  if (f.serviceLineRef) f.serviceLineRef.value = src.serviceLineRef || '';
  f.ruolo.value = src.ruolo || '';
  f.assegnazionePerenne.value = src.assegnazionePerenne || '';
  f.directory.value = src.directory || '';
  f.pim.value = src.pim || '';

  // Perimetri
  const selectedPer = new Set(src.perimetri || []);
  $$('#perimetriGrid input[name="perimetro"]').forEach((i) => {
    i.checked = selectedPer.has(i.value);
  });

  // Tecnici
  const selectedTec = new Set(src.tecnici || []);
  $$('#tecniciGrid input[name="tecnico"]').forEach((i) => {
    i.checked = selectedTec.has(i.value);
  });

  // Accessi
  $$('#resourceGrid select').forEach((sel) => {
    sel.value = src.accessi?.[sel.dataset.resource] || '';
  });

  toast(`Impostazioni copiate da "${src.nome}". Modifica e salva.`);
  // Lo snapshot viene ricalcolato cosi' il dirty-check riparte da qui
  _clientSnapshot = snapshotClientForm();
});

// Tabs e chiusura modali
$$('.tab').forEach((t) => t.addEventListener('click', () => switchTab(t.dataset.tab)));
// Modal cliente: chiusura con dirty-check; gli altri modali chiudono normalmente
$$('#modalCliente [data-close]').forEach((el) => el.addEventListener('click', tryCloseClientModal));
$$('[data-close]').forEach((el) => {
  if (el.closest('#modalCliente')) return;
  el.addEventListener('click', closeModals);
});

// Form salvataggio cliente
document.getElementById('formCliente').addEventListener('submit', async (e) => {
  e.preventDefault();
  const f = e.target;
  // In modalità guidata, "Invio" sui passi iniziali avanza invece di salvare.
  if (typeof isWizardMidStep === 'function' && isWizardMidStep()) {
    wizardGo(1);
    return;
  }
  if (isUtente()) {
    if (!globalThis.editingClientName) {
      toast('Operazione non consentita');
      return;
    }
    const idx = state.clients.findIndex((c) => c.nome === globalThis.editingClientName);
    if (idx < 0) return;
    const oldC = JSON.parse(JSON.stringify(state.clients[idx]));
    const myResource = getCurrentUser()?.resourceName || '';
    if (!myResource) {
      toast('Risorsa non collegata al tuo profilo');
      return;
    }
    const sel = $$('#resourceGrid select').find((s) => s.dataset.resource === myResource);
    if (!sel) return;
    try {
      await api.updateOwnAccess(globalThis.editingClientName, myResource, sel.value || '');
      // S2: invalidazione selettiva — ricarica solo questo cliente
      await refreshClient(globalThis.editingClientName);
      const updated = state.clients.find((c) => c.nome === globalThis.editingClientName);
      const changes = updated ? diffClient(oldC, updated) : [];
      if (changes.length)
        logAudit({
          action: 'update',
          entity: 'Cliente',
          target: globalThis.editingClientName,
          changes
        });
      _suppressDirtyCheck = true;
      _clientSnapshot = null;
      closeModals();
      toast('Accesso aggiornato');
      renderAll();
    } catch (err) {
      console.error(err);
      toast('Errore aggiornamento: ' + (err.message || err));
    }
    return;
  }

  const nome = f.nome.value.trim();
  if (!nome) return;
  const accessi = {};
  $$('#resourceGrid select').forEach((s) => {
    if (s.value) accessi[s.dataset.resource] = s.value;
  });
  const perimetri = $$('#perimetriGrid input[name="perimetro"]:checked').map((i) => i.value);
  const tecnici = $$('#tecniciGrid input[name="tecnico"]:checked').map((i) => i.value);
  const newClient = {
    nome,
    cpl: (f.cpl?.value || '').trim(),
    pm1: (f.pm1?.value || '').trim(),
    pm2: (f.pm2?.value || '').trim(),
    tecnici,
    serviceLineRef: (f.serviceLineRef?.value || '').trim(),
    accessi,
    ruolo: f.ruolo.value.trim(),
    assegnazionePerenne: f.assegnazionePerenne.value,
    directory: f.directory.value,
    pim: f.pim.value,
    perimetri,
    note: f.note.value.trim(),
    tenantId: f.tenantId.value.trim(),
    contratto: {
      numero: f.contrattoNumero.value.trim(),
      tipo: f.contrattoTipo.value.trim(),
      inizio: f.contrattoInizio.value,
      fine: f.contrattoFine.value,
      ore: f.contrattoOre.value,
      importo: f.contrattoImporto.value.trim(),
      note: f.contrattoNote.value.trim()
    },
    referenti: _referenti
      .filter((r) => r.nome || r.email)
      .map((r) => ({ ...r, id: r.id || uid() })),
    documenti: _documenti
      .filter((d) => d.titolo || d.url)
      .map((d) => ({ ...d, id: d.id || uid() })),
    scadenze: _scadenze.filter((s) => s.titolo || s.data).map((s) => ({ ...s, id: s.id || uid() }))
  };

  // Calcolo cambiamenti PRIMA di scrivere, per l'audit
  let oldC = null;
  if (globalThis.editingClientName) {
    const existing = state.clients.find((c) => c.nome === globalThis.editingClientName);
    if (existing) oldC = JSON.parse(JSON.stringify(existing));
  } else if (state.clients.some((c) => c.nome.toLowerCase() === nome.toLowerCase())) {
    const ok = await confirmAction({
      level: 'warning',
      title: 'Nome cliente già esistente',
      message: `Esiste già un cliente di nome "${nome}".`,
      details: [
        'Avrai due record con lo stesso nome in elenco',
        'Lo storico delle modifiche potrebbe confondere le due voci'
      ],
      warning: 'Consigliato: rinomina questo cliente per distinguerlo.',
      confirmText: 'Crea comunque'
    });
    if (!ok) return;
  }

  try {
    await api.saveClient(newClient, globalThis.editingClientName);
    // S2: ricarica solo il cliente toccato (gestisce anche il rename via _clientIdByName)
    await refreshClient(newClient.nome);
    if (oldC) {
      const updated = state.clients.find((c) => c.nome === newClient.nome);
      const changes = updated ? diffClient(oldC, updated) : [];
      if (changes.length)
        logAudit({ action: 'update', entity: 'Cliente', target: newClient.nome, changes });
    } else {
      logAudit({
        action: 'create',
        entity: 'Cliente',
        target: newClient.nome,
        details: `Cliente creato${newClient.cpl ? ' · CPL: ' + newClient.cpl : ''}${newClient.perimetri.length ? ' · Perimetri: ' + newClient.perimetri.join(', ') : ''}`
      });
    }
    _suppressDirtyCheck = true;
    _clientSnapshot = null;
    closeModals();
    toast(globalThis.editingClientName ? 'Cliente aggiornato' : 'Cliente aggiunto');
    renderAll();
  } catch (err) {
    console.error(err);
    toast('Errore salvataggio: ' + (err.message || err));
  }
});

document.getElementById('btnDeleteCliente').addEventListener('click', async () => {
  if (!isAdmin() || !globalThis.editingClientName) return;
  const cli = state.clients.find((c) => c.nome === globalThis.editingClientName);
  const nRef = cli?.referenti?.length || 0,
    nDoc = cli?.documenti?.length || 0;
  const nScad = cli?.scadenze?.length || 0,
    nAccessi = cli?.accessi ? Object.keys(cli.accessi).length : 0;

  // Contratto attivo? (fine futura o assente con almeno un campo compilato)
  const ct = cli?.contratto || {};
  const hasContratto = Object.values(ct).some((v) => v && String(v).trim());
  const fineDate = ct.fine ? new Date(ct.fine) : null;
  const contrattoAttivo = hasContratto && (!fineDate || isNaN(fineDate) || fineDate >= new Date());

  const ok = await confirmAction({
    level: contrattoAttivo ? 'danger' : 'warning',
    title: contrattoAttivo
      ? 'Spostare nel cestino cliente con CONTRATTO ATTIVO'
      : 'Spostare cliente nel cestino',
    message: `Stai per mettere nel cestino il cliente "${globalThis.editingClientName}". I dati collegati non saranno visibili nelle viste finché non lo ripristini:`,
    details: [
      `${nAccessi} mappatur${nAccessi === 1 ? 'a' : 'e'} di accesso`,
      `${nRef} referent${nRef === 1 ? 'e' : 'i'} cliente`,
      `${nDoc} document${nDoc === 1 ? 'o' : 'i'} collegat${nDoc === 1 ? 'o' : 'i'}`,
      `${nScad} scadenz${nScad === 1 ? 'a' : 'e'} attive o registrate`,
      contrattoAttivo
        ? `Contratto ${ct.numero || ''} ${ct.tipo ? '(' + ct.tipo + ')' : ''}${ct.fine ? ' fino al ' + fmtDate(ct.fine) : ''} ATTIVO`
        : '',
      'Puoi ripristinarlo dal Cestino in Sicurezza entro 30 giorni',
      'Lo storico delle modifiche viene mantenuto'
    ].filter(Boolean),
    warning: contrattoAttivo
      ? 'Questo cliente ha un contratto ATTIVO. Sicuro di volerlo mettere nel cestino?'
      : 'Dopo 30 giorni il cliente verrà eliminato definitivamente dal cestino.',
    confirmText: contrattoAttivo ? 'Sposta nel cestino (contratto attivo)' : 'Sposta nel cestino',
    requireType: contrattoAttivo ? 'CESTINO CONTRATTO ATTIVO' : ''
  });
  if (!ok) return;

  // Per i casi con contratto attivo: secondo step di conferma rinforzata
  if (contrattoAttivo) {
    const ok2 = await confirmAction({
      level: 'danger',
      title: 'Ultima conferma',
      message: `Stai veramente eliminando "${globalThis.editingClientName}" che ha contratto attivo.`,
      details: [
        'Verra notificato il team via webhook (se configurato)',
        'Verra creato un backup pre-restore automatico per sicurezza'
      ],
      warning: 'Procedere?',
      confirmText: 'Conferma definitiva',
      requireType: globalThis.editingClientName
        .slice(0, Math.min(15, globalThis.editingClientName.length))
        .toUpperCase()
    });
    if (!ok2) return;
  }

  try {
    const deletedName = globalThis.editingClientName;
    // Snapshot di sicurezza per delete su contratto attivo
    if (contrattoAttivo && typeof backupApi !== 'undefined') {
      try {
        await backupApi.create('manual', `Pre-delete cliente "${deletedName}" (contratto attivo)`);
      } catch {}
    }
    await api.deleteClient(deletedName);
    await loadStateFromSupabase();
    logAudit({
      action: 'delete',
      entity: 'Cliente',
      target: deletedName,
      details: contrattoAttivo
        ? 'Cliente messo nel cestino (CONTRATTO ATTIVO)'
        : 'Cliente messo nel cestino'
    });
    notifyCritical?.('cliente.trashed', { nome: deletedName, contrattoAttivo });
    _suppressDirtyCheck = true;
    _clientSnapshot = null;
    closeModals();
    toast('Cliente spostato nel cestino — ripristinabile per 30 giorni');
    renderAll();
  } catch (err) {
    console.error(err);
    toast('Errore eliminazione: ' + (err.message || err));
  }
});

// Topbar (sempre presente nel DOM): wiring diretto.
document.getElementById('btnAddClient')?.addEventListener('click', () => {
  if (!isAdmin()) return;
  openModal();
});
// La ricerca testuale dei clienti vive ORA nella vista (#clientiSearch), wired in
// wireClientiView (mount-safe). La barra in alto (#globalSearch) apre la ricerca
// globale (palette ⌘K), gestita in global-search.js.

// Filtri + reset: vivono nella vista "clienti" (lazy). Wiring mount-safe e
// idempotente (bindOnce): rieseguito dopo l'iniezione del fragment, senza
// rompere il boot se la vista non è ancora montata.
function wireClientiView() {
  if (!document.getElementById('tbodyClienti')) return; // vista non ancora montata
  // Scorciatoia "Excel" diretta: riusa l'export XLSX che vive dentro al menù.
  bindOnce(document.getElementById('btnQuickXlsx'), 'click', () => {
    document.getElementById('btnExportXLSX')?.click();
  });
  ['filterPM', 'filterAmbiente', 'filterRisorsa', 'filterStato'].forEach((id) => {
    bindOnce(document.getElementById(id), 'change', renderClienti);
  });
  bindOnce(document.getElementById('clientiSearch'), 'input', (e) => {
    renderClienti();
    maybeFuzzyServerSearch(e.target.value || '');
  });
  bindOnce(document.getElementById('btnClearFilters'), 'click', () => {
    ['filterPM', 'filterAmbiente', 'filterRisorsa', 'filterStato'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.value = '';
    });
    const cs = document.getElementById('clientiSearch');
    if (cs) cs.value = '';
    renderClienti();
  });
}
document.addEventListener('DOMContentLoaded', wireClientiView);
globalThis.bus?.on?.('view:lazy-loaded', (p) => {
  if (p && p.viewId === 'clienti') wireClientiView();
});

Object.assign(globalThis, {
  openModal,
  closeModals,
  renderClienti,
  wireClientiView,
  switchTab,
  renderReferentiList,
  renderDocumentiList,
  renderScadenzeListModal
});
export {};
